import { render, staticRenderFns } from "./employeeDetail.vue?vue&type=template&id=11d78461&scoped=true&"
import script from "./employeeDetail.vue?vue&type=script&lang=ts&"
export * from "./employeeDetail.vue?vue&type=script&lang=ts&"
import style0 from "./employeeDetail.vue?vue&type=style&index=0&id=11d78461&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d78461",
  null
  
)

export default component.exports